import * as React from 'react';
import { ItemProps } from './SelectRich';
import styled from 'styled-components';
import { styledWithProps } from '../utils';
import { hoverMixin } from 'utils/style';

interface SelectableProps {
  selected: boolean;
}

const Wrapper = styledWithProps<SelectableProps>()(styled.div)`
  display: flex;
  font-weight: bold;
  align-items: center;
  height: 32px;
  padding-left: 30px;
  padding-right: 20px;
  white-space: nowrap;
  font-size: 15px;
  line-height: 32px;
  border-bottom: 1px solid var(--menu-divider-color);
  background-repeat: no-repeat;
  background-position: center left;
  background-image: ${props =>
    props.selected
      ? `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDIwIDEzIj4KICA8cG9seWxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWI0YmEzIiBzdHJva2Utd2lkdGg9IjEuNSIgcG9pbnRzPSIxMCA2LjUyMSAxMi45ODkgOS41MSAxOS40OTkgMyIvPgo8L3N2Zz4=')`
      : 'none'};

  color: 
  ${props =>
    props.selected
      ? 'var(--accent-color-lighter)'
      : 'var(--primary-text-color)'};

  cursor: pointer;
  * {
    cursor: pointer;
  }

  &:last-child {
    border-bottom: 1px solid transparent;
  }

  ${hoverMixin(`background-color: var(--menu-bg-color-hover);
  border-bottom: 1px solid transparent;`)}
`;

export default class extends React.Component<ItemProps> {
  didClick = () => {
    this.props.onSelected(this.props.value);
  };
  render() {
    const { value } = this.props;
    const label = (value.label ? value.label : value).toString();
    return (
      <Wrapper selected={this.props.selected} onClick={this.didClick}>
        {label}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectOption.tsx